/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './LocationAddedMessage.sass';

class LocationAddedMessage extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.handleCloseMessageModal();
    this.props.seeAllLocations();
  }

  render() {
    const { locationsCount } = this.props;

    return (
      <div className="location-added-message">
        <div className="location-added-message__wrapper information-dropdown">
          <h4 className="location-added-message__title">
            { I18n.t('popup_message.location').one } { I18n.t('popup_message.added') }
          </h4>
          <p className="location-added-message__message-content">
            <span className="bold">
              { locationsCount }
              &nbsp;
              { locationsCount > 1
                ? I18n.t('popup_message.location').other
                : I18n.t('popup_message.location').one }
              &nbsp;
              { I18n.t('popup_message.added') }
            </span>
            &nbsp;
            { I18n.t('popup_message.content') }
          </p>
          <button onClick={this.handleClick} type="button" className="location-added-message__see-all-btn">
            { I18n.t('popup_message.see_all') }
          </button>
        </div>
      </div>
    );
  }
}

LocationAddedMessage.propTypes = {
  seeAllLocations: PropTypes.func,
  handleCloseMessageModal: PropTypes.func,
  locationsCount: PropTypes.number,
};

LocationAddedMessage.defaultProps = {
  seeAllLocations: PropTypes.func,
  handleCloseMessageModal: PropTypes.func,
  locationsCount: null,
};

export default LocationAddedMessage;
